import React from 'react';
import cn from 'classnames';
import { ProductSizeProps, SizeProps } from "../../types";
import { WhitecheckboxWithBackgroundIcon, CircleWithCrossIcon, WarningWithCircleIcon, } from "../../../../ui/Icon";
import MetaText from "../../../../ui/Typography/texts/MetaText";
import styles from './ProductSizes.module.scss';
const getStockIndicatorComponent = (traffLightInd) => {
    switch (traffLightInd) {
        case 'G':
            return React.createElement(WhitecheckboxWithBackgroundIcon, { size: "small", className: styles.icon });
        case 'A':
            return React.createElement(WarningWithCircleIcon, { size: "small", className: styles.icon });
        case 'R':
            return React.createElement(CircleWithCrossIcon, { size: "small", className: styles.icon });
        default:
            return '';
    }
};
const ProductSizes = ({ outOfStockCopy, productsInStore, productSizesElementClassName, outOfStockClassName, }) => {
    const outOfStock = productsInStore === null || productsInStore === void 0 ? void 0 : productsInStore.filter((product) => product.avaiQty && product.avaiQty > 0 && product.traffLightInd !== 'R');
    if ((outOfStock === null || outOfStock === void 0 ? void 0 : outOfStock.length) === 0) {
        return (React.createElement("div", { className: cn(styles.outOfStockText, outOfStockClassName) },
            React.createElement(CircleWithCrossIcon, { size: "small", className: styles.icon }),
            React.createElement(MetaText, { className: cn(styles.size, styles.outOfStock) }, outOfStockCopy)));
    }
    return (React.createElement("div", { className: styles.sizes },
        React.createElement("ul", { className: cn(styles.sizeContainer, productSizesElementClassName) }, productsInStore === null || productsInStore === void 0 ? void 0 : productsInStore.map(({ sizeCode, sizeName, traffLightInd }) => (React.createElement("li", { className: styles.size },
            getStockIndicatorComponent(traffLightInd !== null && traffLightInd !== void 0 ? traffLightInd : ''),
            React.createElement(MetaText, { key: `size-${sizeCode}` }, sizeName)))))));
};
export default ProductSizes;
//# sourceMappingURL=ProductSizes.js.map